import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { setConnection } from "../../redux/slices/certConnectSlice";
import { getContactDesignations } from "../../redux/thunks/designationThunks";
import { toggleModal } from "../../redux/slices/modalSlice";
import { NullBadgeUrl } from "../../tools/utils";
import { OrganizationContactResponse } from "../../types/certWatch";

interface IContactCredentialCardProps {
  connections: OrganizationContactResponse[];
}

export const MyConnectionListView = ({ connections }: IContactCredentialCardProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const handleRowClick = (connection: OrganizationContactResponse) => {
    dispatch(setConnection(connection));
    dispatch(toggleModal("connectionModal"));
    dispatch(getContactDesignations(connection.ContactId));
  };

  return (
<div className="cco_list_view_wrapper" style={{ width: "100%", overflowX: "auto", padding: "10px" }}>
  <table style={{ width: "100%",
    //  borderCollapse: "separate",
    //   borderSpacing: "0 10px"
      minWidth: "600px", fontFamily: "Arial, sans-serif" }}>
    <thead>
  <tr>
    <th
      style={{
        textAlign: "left",
        backgroundColor: "#c67b05",
        color: "#fff",
        padding: "10px 14px",
        borderRadius: "8px 0 0 8px",
      }}
    >
      {t("MyCCOPro.SearchCandidate.name")}
    </th>
    <th
      style={{
        textAlign: "left",
        backgroundColor: "#c67b05",
        color: "#fff",
        padding: "10px 12px",
      }}
    >
      {t("MyCCOPro.SearchCandidate.ccoId")}
    </th>
    <th
      style={{
        textAlign: "left",
        backgroundColor: "#c67b05",
        color: "#fff",
        padding: "10px 18px",
        borderRadius: "0 8px 8px 0",
      }}
    >
   {t('MyCCOPro.SearchCandidate.certificationsHeld')}   </th>
  </tr>
</thead>

<tbody>
  {connections.map((connection, index) => (
   <tr
  key={connection.ContactId + "_" + index}
  onClick={() => handleRowClick(connection)}
  className="table-row"
  style={{
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "700px",
    fontFamily: "Arial, sans-serif",
    cursor: "pointer",
    transition: "background 0.2s ease",
    backgroundColor:"#fff",
  }}
>
      {/* Name + Image */}
      <td
        style={{
          padding: "6px 12px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontWeight: 600,
          verticalAlign: "middle",
        }}
      >
        <img
          src={connection.ContactProfilePic || NullBadgeUrl}
          alt={connection.ContactName}
          style={{
            width: "25px",
            height: "25px",
            objectFit: "cover",
            borderRadius: "6px",
            border: connection.ContactProfilePic
              ? "none"
              : "1px solid rgb(0 0 0 / 10%)",
          }}
        />
        <span style={{ fontSize: "14px", color: "#222", lineHeight: "1" }}>
          {connection.ContactName}
        </span>
      </td>

      {/* CCO ID */}
      <td
        style={{
          padding: "6px 12px",
          fontWeight: 500,
          fontSize: "14px",
          color: "#333",
          textAlign: "left",
          verticalAlign: "middle",
          whiteSpace: "nowrap",
        }}
      >
        {connection.ContactCCOID}
      </td>

      {/* Certifications Held */}
      <td
        style={{
          padding: "6px 12px",
          textAlign: "left",
          verticalAlign: "middle",
          height: "48px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "6px",
            flexWrap: "wrap",
          }}
        >
          {/* Account Locked */}
          {connection.StatusReason === "Approved" &&
            connection.CandidateAccessControl === "Locked" && (
              <span
                style={{
                  backgroundColor: "red",
                  color: "#fff",
                  padding: "3px 8px",
                  borderRadius: "4px",
                  fontWeight: "600",
                  fontSize: "12px",
                  lineHeight: "1",
                }}
              >
                {t("MyCCOPro.SearchCandidate.lockerror")}
              </span>
            )}

          {/* Pending */}
          {connection.StatusReason === "Pending" && (
            <span
              style={{
                backgroundColor: "yellow",
                color: "#000",
                padding: "3px 8px",
                borderRadius: "4px",
                fontWeight: "600",
                fontSize: "12px",
                lineHeight: "1",
              }}
            >
              {t("MyCCOPro.SearchCandidate.pendingError")}
            </span>
          )}

          {/* Photo Not Approved */}
          {connection.StatusReason === "Approved" &&
            connection.CandidateAccessControl !== "Locked" &&
            connection.IsPhotoApproved === false && (
              <span
                style={{
                  backgroundColor: "yellow",
                  color: "#000",
                  padding: "3px 8px",
                  borderRadius: "4px",
                  fontWeight: "600",
                  fontSize: "12px",
                  lineHeight: "1",
                }}
              >
                {t("MyCCOPro.SearchCandidate.photoNotApproved")}
              </span>
            )}

          {/* Certifications */}
          {connection.StatusReason === "Approved" &&
          connection.CandidateAccessControl !== "Locked" &&
          connection.IsPhotoApproved === true ? (
            connection.MyCCODesignationDetails ? (
              (() => {
                const items = connection.MyCCODesignationDetails.split(",").map(
                  (i) => i.trim()
                );
                const firstSeven = items.slice(0, 7);
                const remaining = items.length - 7;

                return (
                  <>
                    {firstSeven.map((item, idx) => (
                      <span
                        key={idx}
                        style={{
                          backgroundColor: "#E37E33",
                          color: "#fff",
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600",
                          lineHeight: "1",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item}
                      </span>
                    ))}
                    {remaining > 0 && (
                      <span
                        style={{
                          backgroundColor: "#E37E33",
                          color: "#fff",
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "600",
                          lineHeight: "1",
                        }}
                      >
                        +{remaining}
                      </span>
                    )}
                  </>
                );
              })()
            ) : (
              <span
                style={{
                  backgroundColor: "#9E9E9E",
                  color: "#fff",
                  padding: "3px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "1",
                }}
              >
                {t("MyCCOPro.SearchCandidate.none")}
              </span>
            )
          ) : null}
        </div>
      </td>
    </tr>
  ))}
</tbody>




  </table>
</div>




  );
};